import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';
import { PROSPECTING_TOOLS_FLAG, PROSPECTING_TOOLS_TABS } from '../ProspectingTools/tabs';

export type ProspectingLinkType = 'prospectingrun' | 'prospectingsearch';

const SEARCH_TAB_PATH = PROSPECTING_TOOLS_TABS.find(tab => tab.key === 'findCompanies')?.path ?? '';

/**
 * Where a prospecting search or run link in a chat message leads (WEB-13173); the run-outcome
 * message links both (WEB-13148). In the Prospecting section a run lives with the searches, so
 * both open its Search tab. Without the section a run keeps its run page, and a search opens
 * AI › Find companies, whose URL has no way to name a session.
 *
 * Host-relative on purpose: the page lives on whichever origin the user is signed in to (WEB-11016).
 */
export const prospectingLinkHref = (type: ProspectingLinkType, id: number): string => {
	if (hasSoftDeployAccess(PROSPECTING_TOOLS_FLAG)) {
		return `/#${SEARCH_TAB_PATH}?${type === 'prospectingrun' ? 'runId' : 'search'}=${id}`;
	}
	return type === 'prospectingrun' ? `/#/prospecting-agent/runs/${id}` : '/#/prospecting-workspace';
};
